export enum IncomeAndAssetsSteps {
    IncomeSource = 'IS',
    InvestmentExtraIncome = 'IEI',
    InvestmentRentalIncome = 'IRI',
    OtherBankStatements = 'OBS',
    OtherIncomeSource = 'OIS',
    OtherSupportIncome = 'OSI',
}